import { addressResponseToAddressObject } from './misc';

const hasValue = (value) => value !== undefined && value !== null && value !== '';

const splitName = (name = '') => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const [firstName, ...rest] = parts;

    return {
        firstName: firstName || '',
        lastName: rest.join(' '),
    };
};

const addressObjectToAddressRequest = (address) => {
    if (!address || typeof address !== 'object') {
        return null;
    }

    const fallbackName = splitName(address.name);
    const request = {
        company_name: address.companyName,
        first_name: address.firstName || fallbackName.firstName,
        middle_name: address.middleName,
        last_name: address.lastName || fallbackName.lastName,
        email: address.email,
        phone: address.phone,
        street1: address.street1,
        street2: address.street2,
        street3: address.street3,
        city_locality: address.cityLocality,
        state_province: address.stateProvince,
        postal_code: address.postalCode,
        country_code: address.countryCode,
        residential_indicator: address.residentialIndicator,
    };

    const hasAddressValue = Object.values(request).some(hasValue);

    return hasAddressValue ? request : null;
};

const parseManifestTrackingNumbers = (value) => {
    if (Array.isArray(value)) {
        return value.map((trackingNumber) => `${trackingNumber}`.trim()).filter(Boolean);
    }

    return `${value || ''}`
        .split(/[,\s]+/)
        .map((trackingNumber) => trackingNumber.trim())
        .filter(Boolean);
};

const manifestObjectToManifestRequest = (manifest) => {
    const request = {
        auto: Boolean(manifest.auto),
        carrier: manifest.carrier,
    };

    const shipmentAddress = addressObjectToAddressRequest(manifest.shipmentAddress);
    const trackingNumbers = parseManifestTrackingNumbers(manifest.trackingNumbers ?? manifest.trackingNumbersText);

    if (shipmentAddress) {
        request.shipment_address = shipmentAddress;
    }

    if (manifest.shipmentDate) {
        request.shipment_date = manifest.shipmentDate;
    }

    if (manifest.inductionPostalCode) {
        request.induction_postal_code = manifest.inductionPostalCode;
    }

    if (manifest.carrierAccountId) {
        request.carrier_account_id = manifest.carrierAccountId;
    }

    if (trackingNumbers.length > 0) {
        request.tracking_numbers = trackingNumbers;
    }

    return request;
};

const manifestResponseToManifestObject = (response) => {
    return {
        id: response.id,
        createdAt: response.created_at,
        shipmentDate: response.shipment_date,
        status: response.status,
        trackingNumber: response.tracking_number,
        carrier: response.carrier,
        carrierPartner: response.partner_carrier,
        auto: response.auto,
        priorityCount: response.priority_count,
        expressCount: response.express_count,
        otherCount: response.other_count,
        groundAdvantageCount: response.ground_advantage_count,
        returnsCount: response.returns_count,
        internationalCount: response.international_count,
        base64ScanForm: response.base64_scan_form,
        scanFormUrl: response.scan_form_url,
        entryFacility: response.entry_facility,
        entryFacilityZip: response.entry_facility_zip,
        entryFacilityZip4: response.entry_facility_zip4,
        shipmentAddress: response.shipment_address && addressResponseToAddressObject(response.shipment_address),
    };
};

export {
    addressObjectToAddressRequest,
    manifestObjectToManifestRequest,
    manifestResponseToManifestObject,
    parseManifestTrackingNumbers,
};
